export type DisneyPromoCountries = (typeof CountriesAvailable)[number];
// prettier-ignore
export const CountriesAvailable = [
	'AT', 'CH', 'DE', 'DK', 'ES', 'FI', 'FR', 'GB', 'IT', 'NO', 'SE', 'PL',
] as const;

type DisneyPromoTexts = Record<DisneyPromoCountries, PromoTexts>;
const PromotionTexts: DisneyPromoTexts = {
	AT: {
		ribbon: 'X-MAS',
		offerText: 'Ab 5,99 €/M',
		longText: 'Weihnachten auf Disney+!',
		endDate: '2023-12-31',
	},
	CH: {
		ribbon: 'X-MAS',
		offerText: 'Ab 5,99 €/M',
		longText: 'Weihnachten auf Disney+!',
		endDate: '2023-12-31',
	},
	DE: {
		ribbon: 'X-MAS',
		offerText: 'Ab 5,99 €/M',
		longText: 'Weihnachten auf Disney+!',
		endDate: '2023-12-31',
	},
	DK: {
		ribbon: null,
		offerText: 'Stream nu',
		longText: 'Fra 49 kr. pr. måned',
		endDate: '2023-12-31',
	},
	ES: {
		ribbon: '5,99€',
		offerText: 'Ver ahora',
		longText: 'Desde solo 5,99€ al mes',
		endDate: '2023-12-31',
	},
	FI: {
		ribbon: null,
		offerText: 'Katso nyt',
		longText: 'Aina uutta viihdettä',
		endDate: '2023-12-31',
	},
	FR: {
		ribbon: null,
		offerText: 'ABONNEMENT',
		longText: 'À partir de 5,99€/mois',
		endDate: '2023-12-31',
	},
	GB: {
		ribbon: null,
		offerText: 'Stream Now',
		longText: 'From just £4.99 p/m',
		endDate: '2023-12-31',
	},
	IT: {
		ribbon: null,
		offerText: 'Abbonati',
		longText: 'A partire da 5,99€/mese',
		endDate: '2023-12-31',
	},
	NO: {
		ribbon: null,
		offerText: 'Strøm nå',
		longText: 'Fra 59 kr per måned',
		endDate: '2023-12-31',
	},
	SE: {
		ribbon: null,
		offerText: 'Streama nu',
		longText: 'Från 59 kr per månad',
		endDate: '2023-12-31',
	},
	PL: {
		ribbon: 'OFERTA',
		offerText: '379,90/rok',
		longText: 'Okazja: 379,90/rok',
		endDate: '2023-12-31',
	},
};

export const DisneyPlusId = 337 as const;

// Types just for fun
type digits = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';
type day = `${'0'}${Exclude<digits, '0'>}` | `${'1' | '2'}${digits}` | '30' | '31';
type month = `${'0'}${Exclude<digits, '0'>}` | '10' | '11' | '12';
type year = `20${digits}${digits}`;
type ISO8601 = `${year}-${month}-${day}`;

interface PromoTexts {
	/** Set `null` to disable. */
	ribbon: string | null;
	/** Set `null` to disable. */
	offerText: string | null;
	/** Set `null` to disable. */
	longText: string | null;
	/** `YYYY-MM-DD` format. */
	endDate: ISO8601;
}

export const getDisneyPromoText: (country: string, currentDate?: Date) => PromoTexts | null = (
	country,
	currentDate = new Date()
) => {
	if (!CountriesAvailable.includes(country as any)) return null;

	const promoText = PromotionTexts[country as DisneyPromoCountries];
	if (+currentDate > new Date(promoText.endDate).setUTCHours(23, 59, 59, 999)) return null;

	return promoText;
};
